import React from "react"

const ModalContext = React.createContext({
	component: null,
	modalProps: null,
	showModal: (
		_component: string | React.FunctionComponent<any> | React.ComponentClass<any, any>,
		_componentProps: { [key: string]: unknown },
		_modalProps?: React.CSSProperties
	) => {},
	hideModal: () => {},
})

const useModal = () => React.useContext(ModalContext)

const ModalProvider = ({ children }) => {
	const [component, setComponent] = React.useState(null)
	const [modalProps, setModalProps] = React.useState({})

	const showModal = (_component, _componentProps, _modalProps) => {
		setComponent(React.createElement(_component, _componentProps))
		if (_modalProps) setModalProps(_modalProps)
		// Side effect
		document && document.querySelector("body").classList.add("u-overflow-hidden")
	}
	const hideModal = () => {
		setComponent(null)
		// Side effect
		document && document.querySelector("body").classList.remove("u-overflow-hidden")
	}

	return (
		<ModalContext.Provider
			value={{
				component,
				modalProps,
				showModal,
				hideModal,
			}}
		>
			{children}
		</ModalContext.Provider>
	)
}

export { useModal, ModalProvider }
